export const EXPENSE_LIST_REQUEST = 'EXPENSE_LIST_REQUEST'
export const EXPENSE_LIST_SUCCESS = 'EXPENSE_LIST_SUCCESS'
export const EXPENSE_LIST_FAIL = 'EXPENSE_LIST_FAIL'

export const EXPENSE_MEMBERS_REQUEST = 'EXPENSE_MEMBERS_REQUEST'
export const EXPENSE_MEMBERS_SUCCESS = 'EXPENSE_MEMBERS_SUCCESS'
export const EXPENSE_MEMBERS_FAIL = 'EXPENSE_MEMBERS_FAIL'

export const EXPENSE_DETAILS_REQUEST = 'EXPENSE_DETAILS_REQUEST'
export const EXPENSE_DETAILS_SUCCESS = 'EXPENSE_DETAILS_SUCCESS'
export const EXPENSE_DETAILS_FAIL = 'EXPENSE_DETAILS_FAIL'
export const EXPENSE_DETAILS_CLEAR_STATE = 'EXPENSE_DETAILS_CLEAR_STATE'

export const EXPENSE_CREATE_REQUEST = 'EXPENSE_CREATE_REQUEST'
export const EXPENSE_CREATE_SUCCESS = 'EXPENSE_CREATE_SUCCESS'
export const EXPENSE_CREATE_FAIL = 'EXPENSE_CREATE_FAIL'
export const EXPENSE_CREATE_MESSAGE_CLEAR = 'EXPENSE_CREATE_MESSAGE_CLEAR'

export const EXPENSE_DELETE_REQUEST = 'EXPENSE_DELETE_REQUEST'
export const EXPENSE_DELETE_SUCCESS = 'EXPENSE_DELETE_SUCCESS'
export const EXPENSE_DELETE_FAIL = 'EXPENSE_DELETE_FAIL'
export const EXPENSE_DELETE_MESSAGE_CLEAR = 'EXPENSE_DELETE_MESSAGE_CLEAR'
